import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './EventsPageLayout.css';

const EventsPageLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isInsights = location.pathname.includes('/events/feedback-insights');
  const isEventsTab = !isInsights;

  return (
    <div className="events-page-layout">
      <div className="events-page-tabs" role="tablist" aria-label="Events sections">
        <button
          type="button"
          role="tab"
          aria-selected={isEventsTab}
          className={`events-page-tab${isEventsTab ? ' is-active' : ''}`}
          onClick={() => navigate('/events')}
        >
          Events
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={isInsights}
          className={`events-page-tab${isInsights ? ' is-active' : ''}`}
          onClick={() => navigate('/events/feedback-insights')}
        >
          Feedback Insights
        </button>
      </div>
      <Outlet />
    </div>
  );
};

export default EventsPageLayout;
